export default __webpack_public_path__ + "static/media/bank.7ace021c.png";